/**
 * @file PDotObjFieldContainer.jsx
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Jun 27, 2024 13:33
 */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import PDotObjField from './PDotObjField';
import { objectDeepCopy, objectExists, stringExists } from 'src/@common/utilities';

function PDotObjFieldContainer(props) {
    const {
        containerSxStyle = { maxWidth: '255px' },
        pDotObj,
        handleBlur = () => { },
    } = props;

    const [fieldErrors, setFieldErrors] = useState({});
    const [formFields, setFormFields] = useState({});
    const [formIsDirty, setFormIsDirty] = useState(false);

    useEffect(() => {
        // initalize the local form fields
        let localObj = {};

        if (objectExists(pDotObj)) {
            localObj = objectDeepCopy(pDotObj);
            setFormFields(localObj);
        }
    }, [pDotObj]);

    const fieldUpdater = (fieldName, value) => {

        // updates localState only
        if (fieldName) {
            const tmpFields = objectDeepCopy(formFields);

            switch (fieldName) {
                case 'hg38.pDot':
                    tmpFields.hg38.pDot = value;
                    setFormFields(tmpFields);
                    setFormIsDirty(true);
                    break;
                case 'hg38.refSeq':
                    tmpFields.hg38.refSeq = value;
                    setFormFields(tmpFields);
                    setFormIsDirty(true);
                    break;
                default:
                    // setFormFields({
                    //     ...formFields,
                    //     [fieldName]: value
                    // });
                    // setFormIsDirty(true);
                    break;
            }
        }
    };

    const handleChange = (event, fieldName) => {

        let str = null;

        if (event) {
            if (event.target.type) {

                const value = event.target.value;

                switch (event.target.type) {
                    case 'autocomplete':
                    case 'text':
                        switch (fieldName) {
                            default:
                                if (value) {
                                    str = value;
                                } else {
                                    str = '';
                                }
                                break;
                        }
                        break;

                    default:
                        str = value;
                        break;
                }

                if (str) {

                    if (stringExists(str)) {
                        str = str.replace('P.', 'p.');
                    }
                }

                // set the updated value in state
                fieldUpdater(fieldName, str);
            }
        }

    };

    const validateField = (fieldName, value) => {

        const isValid = true;

        if (fieldName) {
            let msg = '';

            if (stringExists(value)) {
                if (!value.includes('p.')) {
                    msg = "must have: 'p.' prefix";
                } else {
                    const idx = value.indexOf('p.');
                    if (idx !== 0) {
                        msg = "must have: 'p.' prefix";
                    }
                }
            }

            switch (fieldName) {
                case 'hg38.pDot':
                    setFieldErrors({
                        'hg38.pDot': msg,
                    });

                    break;

                default:
                    break;
            }
        }

        return isValid;
    };

    const localHandleBlur = (fieldName) => {

        if (formIsDirty === true) {

            let value = '';

            switch (fieldName) {
                case 'hg38.pDot':
                    value = formFields.hg38.pDot;
                    break;
                case 'hg38.refSeq':
                    value = formFields.hg38.refSeq;
                    break;
                default:
                    break;
            }

            const isValid = validateField(fieldName, value);

            if (isValid === true) {
                // formFields are sent to update parent state
                handleBlur(formFields);

                setFormIsDirty(false);
            }

        }
    };

    return <PDotObjField
        containerSxStyle={containerSxStyle}
        fieldErrors={fieldErrors}
        formFields={formFields}
        handleBlur={localHandleBlur}
        handleChange={handleChange}
    />
}

PDotObjFieldContainer.propTypes = {
    containerSxStyle: PropTypes.object,
    pDotObj: PropTypes.object,
    handleBlur: PropTypes.func.isRequired,
};

export default PDotObjFieldContainer;